import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import { GeoLookup } from "@app/tools";
import AccuracyEvidence from "./accuracy-evidence/AccuracyEvidence";
import { JSX } from "react";

/** Renders the routing components for the tools sub-section of the app. */

export default function ToolsRouter(props: RouteComponentProps): JSX.Element {
  return (

    <Switch>
      <Route path={`${props.match.path}/:context/:state/:ssa`} component={GeoLookup} />
      <Route path={`${props.match.path}/:context/:zip`} component={GeoLookup} />
      <Route path={`${props.match.path}/accuracyEvidence/:npi`} component={AccuracyEvidence} />
      <Route path={`${props.match.path}/accuracyEvidence/:npi/:temporalPosition`} component={AccuracyEvidence} />

      <Redirect strict={true} exact={true} from={`${props.match.path}/:context/`} to={`${props.match.path}/:context`} />

      <Route path={`${props.match.path}/accuracyEvidence`} component={AccuracyEvidence} />
      <Route path={`${props.match.path}/:context`} component={GeoLookup} />
      <Route component={NotFound} />
    </Switch>
  );
}
